import React, { useState } from 'react';
import { Avatar, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { Link, Redirect } from 'react-router-dom';
import { format, formatDistance } from 'date-fns';

function displayDate(value) {
  const date = new Date(value);
  return value && Number.isFinite(date.getTime()) ? format(date, 'd MMM yyyy') : 'Not available';
}

export default function ProfileCard(props) {
  const [selectedSurvey, setSelectedSurvey] = useState(false);
  const [loadingID, setLoadingID] = useState(null);
  const [error, setError] = useState('');
  const rows = Array.isArray(props.completedSurveys) ? props.completedSurveys : [];
  const lastDate = new Date(props.lastSurveyCompleted);
  const lastCompleted = props.lastSurveyCompleted && Number.isFinite(lastDate.getTime())
    ? formatDistance(lastDate, new Date(), { addSuffix: true }) : null;
  const initials = String(props.fullName || 'Your profile').split(/\s+/).filter(Boolean).slice(0,2).map(part => part[0]).join('').toUpperCase();

  async function getSurveyResults(ID) {
    setError(''); setLoadingID(ID);
    try {
      const response = await fetch('/api/results?SurveyResults=' + encodeURIComponent(ID), {
        method: 'GET', headers: { 'Content-Type': 'application/json' }, credentials: 'include',
      });
      if (!response.ok) throw new Error('We could not open this report. Please retry or contact EntreMap for help.');
      setSelectedSurvey(await response.json());
    } catch (err) { setError(err.message); }
    finally { setLoadingID(null); }
  }

  if (selectedSurvey !== false) return <Redirect push to={{ pathname: '/results', state: selectedSurvey }} />;
  return <div className="emap-profile-grid">
    <Paper component="aside" className="emap-identity-card">
      <Avatar alt={props.fullName || 'Your profile'} src={props.picture || undefined}>{initials}</Avatar>
      <h2>{props.fullName || 'Your profile'}</h2>
      <p>Your EntreMap account</p>
      <div className="emap-identity-details">
        <p>Member since <strong>{displayDate(props.accountCreated)}</strong></p>
        {props.provider && <p>Sign-in method: <strong>{props.provider}</strong></p>}
        <p>{lastCompleted ? `Last assessment completed ${lastCompleted}` : 'Your first completed assessment will appear here.'}</p>
      </div>
      {!props.hasDraft && <Button component={Link} to="/surveylanding" variant="contained" color="primary">Start assessment</Button>}
      {props.hasDraft && <p>Use Resume assessment above to continue your saved work.</p>}
      <div className="emap-profile-support"><Link to="/faq">Help and FAQ</Link><Link to="/contact">Contact us</Link></div>
    </Paper>
    <Paper component="section" className="emap-report-history" aria-labelledby="emap-history-title">
      <div className="emap-report-history-header">
        <div><p className="emap-card-kicker">Reflect on your progress</p><h2 id="emap-history-title">Your completed assessments</h2><p>Open a report to explore your results.</p></div>
        <span className="emap-history-count">{rows.length} {rows.length === 1 ? 'assessment' : 'assessments'}</span>
      </div>
      {error && <p role="alert" className="emap-profile-message">{error} <Link to="/contact">Get help</Link></p>}
      {rows.length ? <TableContainer><Table aria-label="Your completed assessments">
        <TableHead><TableRow><TableCell>Completed on</TableCell><TableCell align="right">Your report</TableCell></TableRow></TableHead>
        <TableBody>{rows.map(survey => <TableRow key={survey.ID}>
          <TableCell component="th" scope="row">{displayDate(survey.date)}</TableCell>
          <TableCell align="right"><Button variant="outlined" color="primary" aria-label={`View report completed ${displayDate(survey.date)}`} disabled={loadingID !== null} onClick={() => getSurveyResults(survey.ID)}>{loadingID === survey.ID ? 'Opening report...' : 'View report'}</Button></TableCell>
        </TableRow>)}</TableBody>
      </Table></TableContainer> : <div className="emap-empty-reports"><h3>A fresh perspective starts here.</h3><p>Once you complete an assessment, your report will be available here. Return to it whenever you want to reflect on your results.</p></div>}
    </Paper>
  </div>;
}
